import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the file icon
 * 
 * @param {Object} props - The props of the component
 * @returns The file icon
 */
const FileIcon = (props) => (
  <Icon viewBox="0 0 19 15" fill="none" {...props}>
    <path d="M1.80775 15C1.30258 15 0.875 14.825 0.525 14.475C0.175 14.125 0 13.6974 0 13.1923V1.80775C0 1.30258 0.175 0.875 0.525 0.525C0.875 0.175 1.30258 0 1.80775 0H7.298L9.298 2H17.1923C17.6974 2 18.125 2.175 18.475 2.525C18.825 2.875 19 3.30258 19 3.80775V13.1923C19 13.6974 18.825 14.125 18.475 14.475C18.125 14.825 17.6974 15 17.1923 15H1.80775ZM8.84625 12.1538H16.1538V11.7963C16.1538 11.1296 15.824 10.6058 15.1645 10.225C14.5048 9.84417 13.6167 9.65375 12.5 9.65375C11.3833 9.65375 10.4952 9.84417 9.8355 10.225C9.176 10.6058 8.84625 11.1296 8.84625 11.7963V12.1538ZM12.5 8.34625C12.9858 8.34625 13.399 8.176 13.7395 7.8355C14.0798 7.49517 14.25 7.08208 14.25 6.59625C14.25 6.11025 14.0798 5.69708 13.7395 5.35675C13.399 5.01642 12.9858 4.84625 12.5 4.84625C12.0142 4.84625 11.601 5.01642 11.2605 5.35675C10.9202 5.69708 10.75 6.11025 10.75 6.59625C10.75 7.08208 10.9202 7.49517 11.2605 7.8355C11.601 8.176 12.0142 8.34625 12.5 8.34625Z" fill="currentColor" />
  </Icon>
);

export default React.memo(FileIcon);
